import React, { createContext } from 'react'
import { useCookies } from 'react-cookie'

// Contexte d'application pour l'auth
const ApplicationContext = createContext()

// Fournisseur de contexte
const ApplicationProvider = ({ children }) => {
  const [cookies, setCookie, removeCookie] = useCookies(['token'])

  const token = cookies.token || null
  const isAuthenticated = Boolean(token)
  
  const [user, setUser] = React.useState(null)
  const [isLoadingUser, setIsLoadingUser] = React.useState(false)

  React.useEffect(() => {
    if (token) {
      setIsLoadingUser(true)
      const API_BASE = process.env.REACT_APP_API_BASE || (process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : 'https://scorebook-api.meew.fr')
      fetch(`${API_BASE}/users/get/my-profile`, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        setUser(data)
        setIsLoadingUser(false)
      })
      .catch(() => {
        setUser(null)
        setIsLoadingUser(false)
      })
    } else {
      setUser(null)
    }
  }, [token])

  // Définit le cookie token avec des options sûres par défaut
  const setTokenCookie = (tokenValue, options = {}) => {
    const now = new Date()
    const defaultExpiry = new Date(now.getTime() + 3 * 60 * 60 * 1000) // 3h
    const cookieOptions = {
      path: '/',
      expires: defaultExpiry,
      sameSite: 'strict',
      // secure should be true in production when served over HTTPS
      secure: window.location.protocol === 'https:',
      ...options,
    }
    setCookie('token', tokenValue, cookieOptions)
  }

  const deleteTokenCookie = (options = {}) => {
    removeCookie('token', { path: '/', ...options })
  }

  return (
    <ApplicationContext.Provider
      value={{ token, isAuthenticated, setTokenCookie, deleteTokenCookie, user, isLoadingUser }}
    >
      {children}
    </ApplicationContext.Provider>
  )
}

export { ApplicationContext, ApplicationProvider }
